import React from 'react';
import { Modal, Table } from 'antd';
import { useThemeSwitcher } from 'react-css-theme-switcher';

import doReturnTheme from '~src/styles/themeEngine';
import IconButton from '~components/_common/IconButton/IconButton';
import icon from '~components/_common/icon/icon';
import translate from '~src/i18n/translate';
import data from './data';

// const click = (item) => {
//   console.log('clicked -> item', item);
// };

const PrintModal = ({ state, clicked }) => {
  const { currentTheme } = useThemeSwitcher();
  const theme = doReturnTheme(currentTheme);

  const style = {
    container: {},
    icons: {
      fontSize: '20px',
      marginTop: '-8px',
    },
    chevronIcon: {
      color: theme.colors.secondary,
      marginTop: '-5px',
    },
    folderIcon: {
      color: theme.colors.yellow,
      fontSize: '20px',
      marginTop: '-7px',
    },
    titleBtn: {
      color: theme.colors.secondary,
      fontSize: '20px',
    },
    closeBtn: {
      color: theme.colors.darkGray,
      marginTop: '18px',
      fontSize: '20px',
      transition: '0.3s',
    },
    green: {
      color: theme.colors.green,
    },
    darkGray: {
      color: theme.colors.darkGray,
    },
    small: {
      fontSize: '16px',
    },
  };

  const columns = [
    {
      title: translate('folder-structure'),
      dataIndex: 'name',
      key: 'name',
      render: (item) => (
        <div style={{ display: 'flex' }}>
          {
            <IconButton
              iconStyle={item.type.iconStyle}
              icon={item.type.icon}
              customStyle={style.icons}
              color={item.type.color}
              backgroundOff
            />
          }{' '}
          {item.name}
        </div>
      ),
    },
    {
      title: translate('size'),
      dataIndex: 'size',
      key: 'size',
      width: '15%',
    },
  ];

  return (
    <Modal
      title={
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
          }}>
          {icon('far', 'print', style.titleBtn)}
          {translate('print-project')}
        </div>
      }
      centered
      visible={state}
      onOk={clicked}
      onCancel={clicked}
      okText={translate('save-as-pdf')}
      cancelText={translate('cancel')}
      closeIcon={icon('far', 'times', style.closeBtn, 'close')}
      width={900}>
      <div>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{ y: '50vh' }}
          defaultExpandAllRows
          expandable={{
            expandIcon: ({ expanded, onExpand, record }) => {
              const isFolder = Object.prototype.hasOwnProperty.call(
                record,
                'children'
              );
              if (isFolder) {
                if (expanded) {
                  return (
                    <IconButton
                      iconStyle="far"
                      icon="chevron-down"
                      customStyle={style.chevronIcon}
                      backgroundOff
                      click={(e) => onExpand(record, e)}
                    />
                  );
                }
                return (
                  <IconButton
                    iconStyle="far"
                    icon="chevron-right"
                    customStyle={style.chevronIcon}
                    backgroundOff
                    click={(e) => onExpand(record, e)}
                  />
                );
              }
              // dummy icon placed so it dosnt mess up
              //  the order of the children displayed
              return (
                <IconButton
                  iconStyle="far"
                  icon="chevron-right"
                  customStyle={style.chevronIcon}
                  color="white"
                  backgroundOff
                  click={(e) => onExpand(record, e)}
                />
              );
            },
          }}
        />
      </div>
    </Modal>
  );
};

export default PrintModal;
